import { createActions, createReducer } from 'reduxsauce'

const situacoesPagamentos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Pagos' },
    { value: 'N', label: 'Não Pagos' },
]
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaDiarias: ['administracao'],
    setNomeConsultaDiarias: ['nome'],
    setCpfConsultaDiarias: ['cpf'],
    setDataEmpenhoInicialConsultaDiarias: ['dataEmpenhoInicial'],
    setDataEmpenhoFinalConsultaDiarias: ['dataEmpenhoFinal'],
    setCargoConsultaDiarias: ['cargo'],
    setSituacaoPagamentoConsultaDiarias: ['situacaoPagamento'],
    limpaFiltroConsultaDiarias: [],
    receberFiltroConsultaDiarias: ['filtroRecebido'],
})

const INITIAL_STATE = {
    administracao: [],
    nome: '',
    cpf: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    cargo: [],
    situacaoPagamento: { value: situacoesPagamentos[0].value, label: situacoesPagamentos[0].label },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: action.nome }
}

const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}

const setDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: action.dataEmpenhoInicial }
}

const setDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: action.dataEmpenhoFinal }
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const setSituacaoPagamento = (state = INITIAL_STATE, action) => {
    return { ...state, situacaoPagamento: action.situacaoPagamento }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_DIARIAS]: setAdministracao,
    [Types.SET_NOME_CONSULTA_DIARIAS]: setNome,
    [Types.SET_CPF_CONSULTA_DIARIAS]: setCpf,
    [Types.SET_DATA_EMPENHO_INICIAL_CONSULTA_DIARIAS]: setDataEmpenhoInicial,
    [Types.SET_DATA_EMPENHO_FINAL_CONSULTA_DIARIAS]: setDataEmpenhoFinal,
    [Types.SET_CARGO_CONSULTA_DIARIAS]: setCargo,
    [Types.SET_SITUACAO_PAGAMENTO_CONSULTA_DIARIAS]: setSituacaoPagamento,
    [Types.LIMPA_FILTRO_CONSULTA_DIARIAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_DIARIAS]: receberFiltro,
})
